export default __webpack_public_path__ + "static/media/grid-3.00c45e56.svg";